import {getEnv} from "../env";
import {callApi, updateStatus} from "../05-utils/commonUtils";

const ACTIONS = {
  FETCH_STATUS_PROGRESS: "FETCH_STATUS_PROGRESS",
  FETCH_STATUS_SUCCESS: "FETCH_STATUS_SUCCESS",
  FETCH_STATUS_FAILED: "FETCH_STATUS_FAILED",
  UPDATE_SETTING_PROGRESS: "UPDATE_SETTING_PROGRESS",
  UPDATE_SETTING_SUCCESS: "UPDATE_SETTING_SUCCESS",
  UPDATE_SETTING_FAILED: "UPDATE_SETTING_FAILED",
};

const getSystemStatus = () => {
  let config = {
    method: "get",
  };

  return (dispatch) => {
    dispatch(updateStatus(ACTIONS.FETCH_STATUS_PROGRESS));
    callApi(
      getEnv("API_SERVER") + "/system_status",
      config,
      null,
      (data) => {
        dispatch(
          updateStatus(ACTIONS.FETCH_STATUS_SUCCESS, {systemStatus: data}),
        );
      },
      (err) => {
        dispatch(updateStatus(ACTIONS.FETCH_STATUS_FAILED, {error: err}));
      },
    );
  };
};

const updateSystemSetting = (data) => {
  let config = {
    method: "post",
    body: {
      name: data.name,
      value: data.value,
    },
  };

  return (dispatch) => {
    dispatch(updateStatus(ACTIONS.UPDATE_SETTING_PROGRESS));
    callApi(
      getEnv("API_SERVER") + "/system_setting",
      config,
      null,
      () => {
        dispatch(
          updateStatus(ACTIONS.UPDATE_SETTING_SUCCESS, {
            setting: {name: data.name, value: data.value},
          }),
        );
      },
      (err) => {
        dispatch(updateStatus(ACTIONS.UPDATE_SETTING_FAILED, {error: err}));
      },
    );
  };
};

export {ACTIONS, getSystemStatus, updateSystemSetting};



// WEBPACK FOOTER //
// ./src/01-actions/system.js